<template>
  <div>
    <lk-form :label-width='60' class="form-row">
      <lk-row>
        <lk-col span='4'>
          <lk-form-item label="患者姓名:">
            <span>{{salePrescription.patientName || ''}}</span>
          </lk-form-item>
        </lk-col>
        <lk-col span='2'>
          <lk-form-item label="性别:">
            <span>{{ gender }}</span>
          </lk-form-item>
          </lk-col>
        <lk-col span='3'>
          <lk-form-item label="年龄:">
            <span>{{salePrescription.patientAge || ''}}</span>
          </lk-form-item>
          </lk-col>
        <lk-col span='4'>
          <lk-form-item label="联系方式:">
            <span>{{salePrescription.patientPhone || ''}}</span>
          </lk-form-item>
        </lk-col>
      </lk-row>
    </lk-form>
  </div>
</template>
<script>


export default {
  name: 'PatientInfos',
  components: {
  },
  props: {
    salePrescription: {
      type: Object,
    },
  },
  computed: {
    gender() {
      const sex = parseInt(this.salePrescription.gender);
      const sexList = ['', '男', '女', '未知'];
      return sexList[sex];
    },
  },
  watch: {
  },
  data() {
    return {
      interviewTask: {},
      checked: true,
    };
  },
  methods: {
  },
  created() {
  },

};
</script>
<style lang="less" scoped>
  .form-row {
    padding: 8px 0 0 30px;
  }
  .ellipsis {
    width: 170px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }
</style>
